<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container">
    <div class="text-left">
      <h3>
        <router-link to="/tarefas">Histórico</router-link>
      </h3>
    </div>
    <div class="text-left">
      <div class="col-sm-12">
        <h4>Filtros
          <a @click.prevent="showFilters=true" v-if="!showFilters" class="glyphicon glyphicon-eye-open"></a>
          <a @click.prevent="showFilters=false" v-if="showFilters" class="glyphicon glyphicon-eye-close"></a>
        </h4>
      </div>
      <template v-if="showFilters">
        <div class="form-group col-sm-2">
          <label class="control-label">Responsável</label>
          <select v-model="filters.coduser" class="form-control">
              <option value="*">Alguem (Todos)</option>
              <option value="2">Fabio</option>
              <option value="3">Felipe</option>
              <option value="4">Jair</option>
              <option value="5">Josue</option>
              <option value="6">Lucas</option>
              <option value="7">Prado</option>
              <option value="8">Regis</option>
              <option value="9">Roberto</option>
              <option value="10">Rodrigo</option>
              <option value="11">Sanguine</option>
              <option value="12">Valni</option>
          </select>
        </div>
        <div class="form-group col-sm-2">
          <label class="control-label">Tipo</label>
          <select v-model="filters.situacao" class="form-control">
            <option value="*">Agenda e Tarefas</option>
            <option value="1">Agenda</option>
            <option value="2">Tarefas</option>
          </select>
        </div>
        <div class="col-sm-2">
          <label for="">Data Minima</label>
          <div class="input-group">
            <input ref="dtmindisplay" value="01/01/1900" type="text" class="form-control" disabled>
            <div class="input-group-btn">
              <button class="btn btn-primary" @click="showCalendarMin=true"><i class="glyphicon glyphicon-calendar"></i></button>
              <Calendario v-if="showCalendarMin" @pickDate="setDateMin" class="calendario"></Calendario>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <label for="">Data Máxima</label>
          <div class="input-group">
            <input ref="dtmaxdisplay" value="31/12/9999" type="text" class="form-control" disabled>
            <div class="input-group-btn">
              <button class="btn btn-primary" @click="showCalendarMax=true"><i class="glyphicon glyphicon-calendar"></i></button>
              <Calendario v-if="showCalendarMax" @pickDate="setDateMax" class="calendario"></Calendario>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <label>Aplicar filtro</label>
          <button @click.prevent="searchWithFilters()" class="btn btn-primary">Pesquisar</button>
        </div>
      </template>
      <div class="col-sm-12">
        <small>{{numrows}} evento(s) encontrados, divididos entre <b>{{ numheaders }}</b> clientes.</small>
        <small v-if="this.$route.query.s"> que contém '{{this.$route.query.s}}'</small>
      </div>
    </div>
    <table>
      <tr>
        <td>Data</td>
        <td>Situacão</td>
        <td>Ver</td>
        <td>Descrição</td>
        <td>Responsável</td>
      </tr>
      <template v-for="item,key in fatos">
        <tr>
          <td colspan="6" style="background:#e1e1e1;"><b>{{ key }}</b></td>
        </tr>
        <tr v-for="fato in item">
          <td>{{ normalizeDate(fato.dt) }}</td>
          <td>{{ fato.situacao }}</td>
          <td>
            <a v-if="fato.situacao==='Agenda'" @click.prevent="select4agenda(fato.cod)" class="glyphicon glyphicon-book" title="Ver Compromisso"></a>
            <a v-else @click.prevent="select4tarefa(fato.cod)" class="glyphicon glyphicon-flag" title="Ver Tarefa"></a>
          </td>
          <td>{{ fato.descr }}</td>
          <td>{{ fato.funcionario }}</td>
        </tr>
      </template>
    </table>
    <br><br><br>
  </div>
</template>

<script>
  import Calendario from './Calendar.vue'
  import Mask from './Mask.js'
  export default {
    name: 'datalist',
    components: { Calendario },
    data () {
      return {
        showFilters: false,
        showCalendarMin: false,
        showCalendarMax: false,
        loading: false,
        dthoje: undefined,
        filters: {
          coduser: '*',
          flag: '*',
          situacao: '*',
          dtmin: '1900-01-01 00:00:00',
          dtmax: '9999-12-31 00:00:00',
          groupby: 'codcli'
        },
        fatos: {},
        numheaders: 0,
        numrows: 0
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/gethistorico.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            const json = response.body
            if (json.status) {
              this.fatos = json.rows
              this.numheaders = json.numheaders
              this.numrows = json.numrows
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/tarefa/u/${cod}`})
      },
      setDateMin (dt) {
        const aaaa = dt.substring(0, 4)
        const mm = dt.substring(4, 6)
        const dd = dt.substring(6, 8)
        this.filters.dtmin = aaaa + '-' + mm + '-' + dd + ' 00:00:00'
        this.showCalendarMin = false
        this.$refs.dtmindisplay.value = dd + '/' + mm + '/' + aaaa
      },
      setDateMax (dt) {
        const aaaa = dt.substring(0, 4)
        const mm = dt.substring(4, 6)
        const dd = dt.substring(6, 8)
        this.filters.dtmax = aaaa + '-' + mm + '-' + dd + ' 23:59:59'
        this.showCalendarMax = false
        this.$refs.dtmaxdisplay.value = dd + '/' + mm + '/' + aaaa
      },
      searchWithFilters () {
        this.load({'keyword': this.$route.query.s, 'filters': this.filters})
        console.log('Busca por Filtros...')
      },
      select4tarefa (cod) {
        this.$router.push({path: `/tarefa/u/${cod}`})
      },
      select4agenda (cod) {
        this.$router.push({path: `/agenda/u/${cod}`})
      },
      normalizeDate (dt) {
        return dt.substring(6, 8) + '/' + dt.substring(4, 6) + '/' + dt.substring(0, 4)
      }
    },
    created: function () {
      this.maskTelefone = Mask.telefone
      const keyword = this.$route.query.s
      const codcli = this.$route.params.id
      if (codcli > 0) {
        this.load({'keyword': keyword, 'codcli': codcli, 'filters': false})
      } else {
        this.load({'keyword': keyword, 'filters': false})
      }
    },
    watch: {
      '$route' (to, from) {
        const keyword = this.$route.query.s
        const codcli = this.$route.params.id
        if (codcli > 0) {
          this.load({'keyword': keyword, 'codcli': codcli, 'filters': false})
        } else {
          this.load({'keyword': keyword, 'filters': false})
        }
      }
    }
  }
</script>

<style scoped>
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 80vw;
    }
    table tr:not(.*) {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1):not(.*) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    .calendario {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 100;
    }
    @media (max-width: 500px) {
      table {
        font: 10px sans-serif;
      }
      .lt500 {
        display: none;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/TarRelHistory.vue